import * as yup from "yup";

export const addAndChangeSchemaGrouper = (translate: Function) => yup.object().shape({
	mee001Titulo: yup.string().required(translate("Título é requerido"))
});

export const deleteSchemaStrategy = (translate: Function) => yup.object().shape({
	mee001Titulo: yup.string().required(translate("Nome da estratégia não confere")).oneOf([yup.ref("mee001TituloConfirmation")], translate("Nome da estratégia não confere"))
});


export const addAndChangeSchemaItem= (translate: Function) => yup.object().shape({
	mea003Id: yup.number()
		.transform((value,originalValue) => {
			if(!originalValue && originalValue!==0 && originalValue!=="0")
				return null;
			return typeof originalValue !== "string" ? value : parseInt(originalValue,10);
		})
		.when("isObjective",(isObjective,schema) => isObjective ? schema.required(translate("Campo é requerido")):schema.nullable()),
	mes002Id: yup.number()
		.transform((value,originalValue) => {
			if(!originalValue && originalValue!==0 && originalValue!=="0")
				return null;
			return typeof originalValue !== "string" ? value : parseInt(originalValue,10);
		})
		.when("isObjective",(isObjective,schema) => !isObjective ? schema.required(translate("Campo é requerido")):schema.nullable())
});

export const deleteSchema = (translate: Function) => yup.object().shape({
	mab001Titulo: yup.string().required(translate("Titulo da análise não confere")).oneOf([yup.ref("mab001TituloConfirmation")], translate("Titulo da análise não confere"))
});
